
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getMemberDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getMemberDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"memberId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"firstnameEn"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastnameEn"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"firstnameAr"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastnameAr"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"phone"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"gender"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dob"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"relationshipToPrimary"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"memberIdStr"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"primaryCustomerName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"primaryCustomerId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"activeSubscriptionName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"activeSubscriptionPrice"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"daysRemaining"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"expiryDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pendingMealSelectionDays"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"deliveryMode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"deliveryAddressText"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"timeline"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"date"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"healthExclusions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allergies"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dislikes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dailyCalories"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dailyProtein"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dailyCarbs"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dailyFat"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":644}};
    doc.loc.source = {"body":"query getMemberDetails($memberId: ID!) {\n  getMemberDetails(memberId: $memberId) {\n    _id\n    firstnameEn\n    lastnameEn\n    firstnameAr\n    lastnameAr\n    phone\n    gender\n    dob\n    relationshipToPrimary\n    status\n    memberIdStr\n    primaryCustomerName\n    primaryCustomerId\n    activeSubscriptionName\n    activeSubscriptionPrice\n    daysRemaining\n    expiryDate\n    pendingMealSelectionDays\n    deliveryMode\n    deliveryAddressText\n    timeline {\n      title\n      date\n      type\n      status\n    }\n    healthExclusions {\n      allergies\n      dislikes\n      dailyCalories\n      dailyProtein\n      dailyCarbs\n      dailyFat\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["getMemberDetails"] = oneQuery(doc, "getMemberDetails");
        
